import { render, staticRenderFns } from "./InstalacoesGestaoBP.vue?vue&type=template&id=4f5cebc4&scoped=true"
import script from "./InstalacoesGestaoBP.vue?vue&type=script&lang=js"
export * from "./InstalacoesGestaoBP.vue?vue&type=script&lang=js"
import style0 from "./InstalacoesGestaoBP.vue?vue&type=style&index=0&id=4f5cebc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5cebc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})
